export default "__VITE_ASSET__Brc0WOhD__"